<template>
    <div class="oldInnerWrapper tabContent" id="antwort1">
        <form>
            <label style="margin-top:20px">Antwort</label>
            <textarea name="reply" placeholder="Deine Antwort..." v-model="replyElement.text" v-validate="'required'" :class="{'error': errors.has('reply')}"></textarea>
            
            <hr/>
            
            <div class="textAlignRight buttonBlockContainerRight">
                <button type="button" v-on:click="cancel" class="btn btn-white teaserButton width50">Abbrechen</button>
                <button type="button" 
                    v-on:click="save"
                    :disabled="errors.any()"
                    :class="['btn', 'btn-white', 'teaserButton', 'width50']">
                        <span>Speichern</span>
                </button>
            </div>
        </form>
    </div><!-- end antwort1 -->
</template>

<script>
    import {DoubleBounce} from 'vue-loading-spinner'
	export default {
		name: 'userContentReply',
		props: {
            project: String,
            contentkey: String,
            replycontentkey: String
        },
        data: function() {
        	return {
                inSave: false,
                replyToElement: {
                    id: null,
                    kind: 'text',
                    type: 'replyreplyto',
                    text: null
                },
                replyElement: {
                    id: null,
                    kind: 'text',
                    type: 'replyreply',
                    text: null
                },
                model: {
                    id: null,
                    type: 'reply',
                    elements: []
                }
        	}
        },
        created: function() {
            if (this.contentkey) {
                this.load();
            } else {
                this.replyToElement.text = this.replycontentkey;
                this.model.elements.push(this.replyToElement, this.replyElement);
            }
        },
        methods: {
            cancel: function() {
                console.log('cancel clicked');
                this.$emit('cancel');
                return false;
            },
            load: function() {
                var self = this;
                jQuery.ajax ({
                    url: '/project/' + self.project + '/content/' + self.contentkey,
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        self.model = data;
                        self.replyToElement = self.model.elements[0];
                        self.replyElement = self.model.elements[1];
                    },
                    error: function() {alert("error");}
                });
            },
            save: function() {
                if (this.inSave) {
                    return;
                }
                this.$validator.validateAll();
                if (this.errors.any()) {
                    return;
                }
                this.inSave = true;
                var self = this;
                jQuery.ajax ({
                    url: '/project/' + self.project + '/content',
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(self.model),
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        window.location.href = '/project/' + self.project + '/content.html';
                    },
                    error: function() {
                        self.inSave = false;
                        alert("error");
                    }
                });
            }
        },
        components: { DoubleBounce }
	}
</script>


// WEBPACK FOOTER //
// UserContentReply.vue?6dbc455c